import React from 'react';
import {DataFetcherProvider} from './context';
import {SuccessResult} from './types';

export const wrapAppWithDataFetcherProvider = (
  App: React.ReactElement,
  disableDevTools?: boolean,
) => {
  const initialState = getInitialState();
  const hasInitialState = initialState !== null;
  const initialData = initialState ?? new Map();

  return {
    content: (
      <DataFetcherProvider
        initialData={initialData}
        disableDevTools={disableDevTools}
      >
        {App}
      </DataFetcherProvider>
    ),
    hasInitialState,
  };
};

const getInitialState = () => {
  const initialStateElement = document.querySelector(
    '[data-tadarida-initial-state]',
  );

  if (!initialStateElement) {
    return null;
  }

  try {
    const initialState = new Map<string, SuccessResult<unknown>>(
      JSON.parse(initialStateElement.innerHTML),
    );

    return initialState;
  } catch (e) {
    console.warn(e);

    return null;
  }
};
